import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_VALIDACAO } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoDistratoEditRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import { cadastroContratoEntePrivado } from '../../../../../store/modules/ContratosEntePrivadoActions';
import {
  changeContratoEntePrivadoEditingValue,
  buscarLinhasOrcamentarias,
} from '../../../../../store/modules/ContratosEntePrivadoActions';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import ArrowForwardIcon from '../../../../../components/Icons/ArrowForwardIcon';
import GenericDados from './GenericDados';
import { openModal } from '../../../../../store/modules/ModalActions';
import CadastroAnexoIModal from './CadastroAnexoIModal';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import PlanoTrabalho from '../../../../../components/PlanoTrabalho/PlanoTrabalho';
import styles from './DadosAnexoI.scss';
import { fixAllPlanosTrabalhoIndex } from '../../../../../utils/ContratoEntePrivadoUtils';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  sending: false,

  dataInicioChanged: false,
  totalMesesChanged: false,
  dataFimChanged: false,
  reembolsoChanged: false,
};

class DadosAnexoI extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        {this.props.contratosEntePrivado.contratoEditing.planoTrabalho.length >
        0 ? (
          <Col
            cols={[12, 12, 12, 12, 12]}
            className={
              genericCardStyles.rootClassName + '-modal-cadastro-buttom'
            }
          >
            <CustomButton
              className={rootClassName + `-modal-cadastro-buttom`}
              label={this.props.languageValues.labelPlanoDeTrabalho}
              theme='pufvYellow'
              onClick={this.addPlanoTrabalho}
              disabled={this.fieldDisabled()}
              rightIcon={<AddIcon />}
            />
          </Col>
        ) : null}
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            label={this.props.languageValues.proxima}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                this.toSubmit(
                  0,
                  this.props.contratosEntePrivado.contratoEditing
                );
              }
            }}
            rightIcon={<ArrowForwardIcon />}
            disabled={this.submitButtonIsDisabled()}
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    return this.props.loading || this.state.sending || !this.formIsValid();
  };

  fieldDisabled = () => {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.entePrivado.edit) {
        return true;
      }
    }
    return this.state.sending || this.props.loading;
  };

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentDidMount() {
    this.props.buscarLinhasOrcamentarias();
  }

  componentWillUnmount() {
    this.reset();
  }

  formIsValid() {
    return true;
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cardAnexoITitle}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.props.loading,
      },
    };
  };

  submitCallbackStart = () => {
    this.setState({
      sending: true,
    });
  };

  submitCallbackSuccess = () => {
    this.setState({
      sending: false,
    });
    const idContrato =
      this.props.contratosAssessores.contratoEditing.idContrato;
    const idAditivo = this.props.contratosAssessores.contratoEditing.idAditivo;
    const idDistrato =
      this.props.contratosAssessores.contratoEditing.idDistrato;
    const etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        this.props.history.push(
          contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idAditivo,
            etapa
          )
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        this.props.history.push(
          contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idDistrato,
            etapa
          )
        );
        break;
      default:
        this.props.history.push(
          contratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            etapa
          )
        );
        break;
    }
  };

  submitCallbackError = () => {
    this.setState({
      sending: false,
    });
  };

  changePlanoTrabalho = (planoTrabalho, indexToRemove) => {
    let planosTrabalho = [
      ...(this.props.contratosEntePrivado.contratoEditing.planoTrabalho || []),
    ];
    if (planoTrabalho) {
      if (
        planosTrabalho.length > 0 &&
        planoTrabalho.index > -1 &&
        planoTrabalho.index < planosTrabalho.length
      ) {
        planosTrabalho[planoTrabalho.index] = planoTrabalho;
      } else {
        planosTrabalho.push(planoTrabalho);
      }
    }
    if (indexToRemove > -1) {
      planosTrabalho.splice(indexToRemove, 1);
    }
    planosTrabalho = fixAllPlanosTrabalhoIndex(planosTrabalho);
    this.setValue({
      target: {
        name: 'planoTrabalho',
        value: planosTrabalho,
      },
    });
  };

  addPlanoTrabalho = () => {
    this.props.openModal(CadastroAnexoIModal, {
      savedCallback: this.changePlanoTrabalho,
    });
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(
                2,
                this.props.contratosEntePrivado.contratoEditing,
                this.submitCallbackStart,
                this.submitCallbackSuccess,
                this.submitCallbackError
              );
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          {
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + `-plano-trabalho-table`}
              >
                <PlanoTrabalho
                  addPlanoTrabalho={this.addPlanoTrabalho}
                  changePlanoTrabalho={this.changePlanoTrabalho}
                  fieldDisabled={this.fieldDisabled}
                />
              </Col>
            </Row>
          }
        </form>
      </GenericCardScreen>
    );
  }
}

DadosAnexoI.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePrivadoEditingValue,
      cadastroContratoEntePrivado,
      buscarLinhasOrcamentarias,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosAnexoI));
